import React from 'react';

import PropTypes from 'prop-types';

import { AvatarWithName } from '../../../../../shared/components/Avatar';

const NameCell = ({ person }) => {
  const { avatarColor, fullName, initials } = person;

  return (
    <AvatarWithName avatarColor={avatarColor} fullName={fullName} initials={initials} />
  );
};

NameCell.propTypes = {
  person: PropTypes.shape({
    avatarColor: PropTypes.string.isRequired,
    fullName: PropTypes.string.isRequired,
    initials: PropTypes.string.isRequired,
  }).isRequired,
};

export default NameCell;
